import { render } from "./ArticleTab.vue?vue&type=template&id=3ffbb176&scoped=true"
import script from "./ArticleTab.vue?vue&type=script&lang=js"
export * from "./ArticleTab.vue?vue&type=script&lang=js"

import "./ArticleTab.vue?vue&type=style&index=0&id=3ffbb176&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ffbb176"]])

export default __exports__